import { createTheme as createMuiTheme } from '@mui/material/styles';

import palette from './palette';
import MuiButton from './overrides/MuiButton';
import MuiCard from './overrides/MuiCard';
import MuiChip from './overrides/MuiChip';

export default createMuiTheme({
  palette,
  components: {
    MuiButton,
    MuiCard,
    MuiChip,
  },
});
